@if (loading()) {
    <div class="horizontal-bar-chart skeleton">
        <div class="row header">
            <span class="label-col"></span>
            <span class="bar-col skeleton-text header-skeleton"></span>
            <span class="target-col skeleton-text header-skeleton"></span>
        </div>

        @for (row of skeletonRows; track row) {
            <div class="row">
                <span class="label-col skeleton-text label-skeleton"></span>
                <span class="bar-col">
                    <div class="bar-background">
                        <div class="bar-fill skeleton-bar"></div>
                    </div>
                </span>
                <span class="target-col skeleton-text target-skeleton"></span>
            </div>
        }
    </div>
} @else {
    <div class="horizontal-bar-chart">
        <div class="row header">
            <span class="label-col"></span>
            <span class="bar-col">{{ scoreLabel() | translate }}</span>
            <span class="target-col">{{ targetLabel() | translate }}</span>
        </div>

        @for (bar of animatedBars(); track bar.label) {
            <div class="row" [class.combined-bar]="bar.isCombinedBar">
                <span class="label-col">{{ bar.label | translate }}</span>
                <span
                    class="bar-col"
                    appTooltip
                    trigger="hover"
                    position="top"
                    [showDelay]="100"
                    [hideDelay]="100"
                    [componentData]="bar.tooltip"
                >
                    <div class="bar-background">
                        <div class="bar-fill" [style.width.%]="bar.animatedWidth" [style.background-color]="bar.color"></div>
                        <span class="bar-value" [style.left.%]="bar.animatedWidth">
                            {{ bar.displayValue }}
                        </span>
                    </div>
                </span>
                <span class="target-col">{{ bar.targetValue }}</span>
            </div>
        }
    </div>
}
